import { Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { SamePathAppVersion } from '../app.version.enum';
import { allowedProductGuard, clientConfigAppGuard, isSportsVersionMatch } from '../guards';

const SPORTS_BETSTATION_ROUTES: Routes = [];

export default [
    {
        path: 'sports',
        children: SPORTS_BETSTATION_ROUTES,
        canMatch: [allowedProductGuard, isSportsVersionMatch(SamePathAppVersion.SPORTS_BETSTATION_APP)],
        canActivate: [clientConfigAppGuard],
        data: {
            product: ClientConfigProductName.SPORTS,
            canPreload: [isSportsVersionMatch(SamePathAppVersion.SPORTS_BETSTATION_APP), allowedProductGuard],
        },
    },
] satisfies Routes;
